// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__1_G48","story-card":"organism1-m__story-card__20zMs"};